import { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, Transition, Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import CommonButton from "../../common/CommonButton";
import { RxCross2 } from "react-icons/rx";
import AppContext from "../../../context/AppContext";
import { getAllAgentList, getAllGeoCode, getAllOutstandingRange, getAllSpecialAssign, getAllTypeCode, getUpdateSpecialAssign } from "../../../service/Configuration";
import ReactSelector from "../../common/CommonReactSelector";
import { components } from 'react-select';
const Placeholder = (props) => {
  return <components.Placeholder {...props} />;
};

export default function ChangeRuleModal({ open, setOpen, selectedItem, setSpecialAssign }) {

    const [GeoCodes, setGeoCodes] = useState([])
    const [typeCodes, setTypeCodes] = useState([])
    const [outstanding_range, setOutStandingRange] = useState([])
      const [rule_list, setRuleList] = useState({
        id: selectedItem?.id,
        assigneeIds:[],
        areaCodes:[],
        typeCodes:[],
        outstandingRange:[],
        active : "true",
      })

    const { activityId } = useContext(AppContext);
    const organizationId = JSON.parse(localStorage.getItem("selectedOrgId"))
  
    const handleGeoCode = (selectedGeo) => {
      const value = selectedGeo?.map((geo) => geo.value)
      setRuleList({
        ...rule_list,
        areaCodes:value
      })
    }
    const handleTypeCode = (selectedType) => {
      const value = selectedType?.map((type) => type.value)
      setRuleList({
        ...rule_list,
        typeCodes:value
      })
    }
    const handleOutStanding = (selectedRange) => {
      const value = selectedRange?.map((range) => range.value)
      setRuleList({
        ...rule_list,
        outstandingRange:value
      })
    }

  const handleUpdateRule =async () => {

    const result  = await getAllAgentList(organizationId)

    const matchingUserIds = selectedItem.userNames.map(name => {
      const user = result.find(u => u.name === name);
      return user ? user.userId : null;
    }).filter(id => id !== null);


    const payload = {
      rule: {
        ...rule_list,
        assigneeIds: matchingUserIds // Include updated assigneeIds
      },
      assign: false
    }

    const results = await getUpdateSpecialAssign({ payload })
    if (results === "Updated Successfully") {
      const data = await getAllSpecialAssign(activityId, 0, 10)
      setSpecialAssign(data?.ruleList)
    }
    setOpen(false)

  }
     useEffect(() => {
        const fetchOutstandingRange = async () => {
          try {
            const result = await getAllOutstandingRange()
            setOutStandingRange(result)
          } catch (error) {
            console.error('Error fetching outstanding range:', error);
          }
        }
        fetchOutstandingRange()
      }, [])
    
      useEffect(() => {
        const fetchTypesCode = async () => {
          try {
            const result = await getAllTypeCode(activityId)
            setTypeCodes(result)
          } catch (error) {
            console.error('Error fetching type code:', error);
          }
        }
        
        const fetchGeoCode = async () => {
          try {
            const result = await getAllGeoCode(activityId)
            setGeoCodes(result)
          } catch (error) {
            console.error('Error fetching geo code:', error);
          }
        }
    
        fetchTypesCode()
        fetchGeoCode()
    
      }, [activityId])
  

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setOpen}>
        {/* Background Overlay */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-4xl rounded-lg bg-white shadow-xl transform transition-all p-6 flex flex-col gap-[27px]">
              {/* Title */}
              <Dialog.Title className="text-base font-bold text-[#000000] text-left flex justify-between">
                Rule for Rajah Al 
                
                 <button
                                  type="button"
                                  className="text-gray-600 transition-transform transform hover:scale-110 w-[20px] h-[20px]"
                                onClick={() => setOpen(false)}
                                >
                                  <RxCross2 className="h-6 w-6" />
                                </button>
              </Dialog.Title>

              {/* Dropdowns */}
              <div className="mt-2 flex justify-between w-full space-x-2">
                <div className="max-w-[286px] w-full">
                  <ReactSelector
                    options={
                      (GeoCodes || [])?.filter(Boolean)?.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                    onChange={handleGeoCode}
                    components={Placeholder}
                    placeholder={'Select Geo Code'}
                    isClearable={false}
                    isMulti
                    background={'#EBF5FF'}
                    optionbackground={"#EBF5FF"}
                    height={(rule_list.areaCodes.length > 0) ? (rule_list.areaCodes.length) * "27px" : "46px"}
                    overflow="overlay"
                  />
                </div>
                <div className="max-w-[286px] w-full">
                  <ReactSelector
                    options={
                      (typeCodes || [])?.filter(Boolean)?.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                    onChange={handleTypeCode}
                    components={Placeholder}
                    placeholder={'Select Type Code'}
                    isClearable={false}
                    isMulti
                    background={'#EBF5FF'}
                    optionbackground={"#EBF5FF"}
                    height={(rule_list.typeCodes.length > 0) ? (rule_list.typeCodes.length) * "27px" : "46px"}
                    overflow="overlay"
                  />
                </div>
                <div className="max-w-[296px] w-full">
                  <ReactSelector
                    options={
                      (outstanding_range || [])?.filter(Boolean)?.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                    onChange={handleOutStanding}
                    components={Placeholder}
                    placeholder={'Select Amount Range'}
                    isClearable={false}
                    isMulti
                    background={'#EBF5FF'}
                    optionbackground={"#EBF5FF"}
                    height={(rule_list.outstandingRange.length > 0) ? (rule_list.outstandingRange.length) * "27px" : "46px"}
                    overflow="overlay"
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-center gap-[4px]">
                <CommonButton
                  onClick={handleUpdateRule}
                  className="w-20 !px-[10px] !block rounded-sm"
                  variant="primary"
                >
                  Ok
                </CommonButton>

                <button
                  onClick={() => setOpen(false)}
                  className="w-20 rounded-sm border border-[#236DB4] text-[#236DB4] text-xs font-bold"
                >
                  Cancel
                </button>
              </div>

            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
